import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-mng',
  templateUrl: './wallet-mng.component.html',
  styleUrls: ['./wallet-mng.component.scss']
})
export class WalletMngComponent {

}
